import { inject } from "vue";

export default () => {
  // Pega o padrão do java e formata bunitin
  function paraLocalDate(dateTime) {
    const date = new Date(dateTime);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();

    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }

    return `${dt}/${month}/${year}`;
  }

  function isIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  function getClienteFromUrl() {
    const path = window.location.pathname;

    if (path.includes("bot-standalone")) {
      return path.split("/")[2];
    } else {
      return path.split("/")[1];
    }
  }

  function paraLocalDateTime(dateTime) {
    const date = new Date(dateTime);
    let minutes = date.getMinutes();
    let hour = date.getHours();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (hour < 10) {
      hour = "0" + hour;
    }
    return `${paraLocalDate(dateTime)} ${hour}:${minutes}`;
  }

  function paraLocalDateTimeQuebraDeLinha(dateTime) {
    const date = new Date(dateTime);
    let minutes = date.getMinutes();
    let hour = date.getHours();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (hour < 10) {
      hour = "0" + hour;
    }
    return `${paraLocalDate(dateTime)} \n ${hour}:${minutes}`;
  }

  function pesquisarEmArray(input, array) {
    if (input) {
      return array.filter(obj => {
        const objPlanificada = JSON.stringify(removerKeys(obj)).toLowerCase();
        return objPlanificada.indexOf(input.toLowerCase()) > -1;
      });
    }

    return array;
  }

  function toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        resolve({
          conteudo: reader.result.replace(/^data:.+;base64,/, ""),
          nome: file.name,
          contentType: file.type || "text/plain"
        });
      reader.onerror = error => reject(error);
    });
  }

  // função que pega um base64 e um content type e tranforma nesse data, utilizado para
  // carregar funções dinamicamente
  function toDataURL(base64, contentType) {
    if (base64 && contentType) {
      return `data:${contentType};base64,${base64}`;
    }
    return "";
  }

  function removerKeys(obj) {
    let valores = Object.values(obj);
    let resultado = [];
    for (let index in valores) {
      let valor = valores[index];
      let tipo = typeof valor;
      if (tipo == "object" && valor !== null) {
        let valorSemKeys = removerKeys(valor);
        resultado = resultado.concat(valorSemKeys);
      } else {
        if (valor !== null && tipo !== "boolean") {
          resultado.push(valor);
        }
      }
    }
    return resultado;
  }

  function limparObjeto(obj) {
    const arrayKeys = Object.keys(obj);
    arrayKeys.forEach(k => {
      if (Array.isArray(obj[k])) {
        obj[k] = [];
        return;
      }
      if (typeof obj[k] === "object") {
        obj[k] = {};
        return;
      }
      obj[k] = "";
    });
  }

  function mostrarModal(idModal) {
    window.jQuery(`#${idModal}`).modal("show");
  }

  function esconderModal(idModal, time) {
    function hide() {
      window.jQuery(`#${idModal}`).modal("hide");
    }
    if (!!time) setTimeout(hide, time);
    else hide();
  }

  function verificarPreenchimentoCampos() {
    const elementsRequired = document.querySelectorAll("[required]");
    let valid = true;
    resetarValidacao();
    elementsRequired.forEach(e => {
      if (!e.value) {
        e.classList.add("invalid");
        valid = false;
      }
    });
    return valid;
  }

  function validarPreenchimentoCamposRequired(texto) {
    const elementsRequired = document.querySelectorAll("[required]");
    const spanElements = document.querySelectorAll("span");
    const spanTexto = document.getElementById("texto");
    const divEditor = document.getElementById("editor");
    let valid = true;

    resetarValidacao();
    resetarSpanValidacao();

    elementsRequired.forEach(e => {
      if (!e.value) {
        e.classList.add("invalid");
        spanElements.forEach(span => {
          if (span.id == e.id) {
            span.innerHTML = span.id.inputEmBranco();
            span.setAttribute("style", "display:block;");
          }
        });
        valid = false;
      }
    });

    if (!texto || texto == "") {
      spanTexto.innerHTML =
        "Insira uma mensagem no chamado, o campo não pode estar em branco";
      spanTexto.setAttribute("style", "display:block;");
      divEditor.classList.add("invalid");
      valid = false;
    }

    return valid;
  }

  String.prototype.inputEmBranco = function() {
    return (
      this.charAt(0).toUpperCase() +
      this.substr(1) +
      " não pode estar em branco"
    );
  };

  /*function validarTextoEditor(texto){    
    const spanTexto = document.getElementById("texto");
    const divEditor = document.getElementById("editor");

    if(!texto || texto == ""){        
      spanTexto.innerHTML = "Insira uma mensagem no chamado, o campo não pode estar em branco";
      spanTexto.setAttribute("style", "display:block;"); 
      divEditor.classList.add("invalid");      
    } 
  }*/

  function resetarValidacao() {
    const elements = document.querySelectorAll(".invalid");
    elements.forEach(e => e.classList.remove("invalid"));
  }

  function resetarSpanValidacao() {
    const spanElements = document.querySelectorAll("span");
    spanElements.forEach(s => {
      if (s.id != "whatsapp" && s.id != "") {
        s.innerHTML = "";
        s.setAttribute("style", "display:none;");
      }
    });
  }

  function getClientState() {
    const clienteState = inject("clienteState");
    return clienteState;
  }

  function removerLetrasDeUrl(url, nRemover) {
    if (url.slice(-1).includes("/")) {
      return url.slice(0, -Math.abs(nRemover) - 1);
    } else {
      return url.slice(0, -Math.abs(nRemover));
    }
  }

  function concatenaUrl(url, add) {
    if (url.slice(-1).includes("/")) {
      return url + add;
    } else {
      return url + "/" + add;
    }
  }

  return {
    paraLocalDate,
    paraLocalDateTime,
    paraLocalDateTimeQuebraDeLinha,
    pesquisarEmArray,
    limparObjeto,
    toBase64,
    toDataURL,
    mostrarModal,
    esconderModal,
    verificarPreenchimentoCampos,
    validarPreenchimentoCamposRequired,
    isIframe,
    getClienteFromUrl,
    resetarSpanValidacao,
    getClientState,
    concatenaUrl,
    removerLetrasDeUrl
  };
};
